module.exports = __webpack_public_path__ + "img/entusiasmada.926760ea.png";